(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		this.header = document.querySelector('.shopify-section-header');
		this.headerWrapper = document.querySelector('.header-wrapper');
		this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
		this.headerBounds = {};
		this.currentScrollTop = 0;
		this.preventReveal = false;
		this.predictiveSearch = this.querySelector('predictive-search');
		this.colorScheme = document.querySelector('main').querySelectorAll('.shopify-section')[0]?.querySelector('[data-header-transparent]')?.getAttribute('data-header-transparent-color-scheme') || "";
		this.isLightLogo = document.querySelector('main').querySelectorAll('.shopify-section')[0]?.querySelector('[data-header-transparent]')?.getAttribute('data-header-light-logo') || "";

		this.onScrollHandler = this.onScroll.bind(this);
		this.hideHeaderOnScrollUp = () => this.preventReveal = true;

		this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.addEventListener('scroll', this.onScrollHandler, false);

		this.createObserver();

		if (this.isLightLogo == 'true')
			this.header.classList.add('header--light-logo');
		else 
			this.header.classList.remove('header--light-logo');
	}

	disableScroll() {
		window.removeEventListener('scroll', this.onScrollHandler);
	}

	enableScroll() {
		window.addEventListener('scroll', this.onScrollHandler, false);
	}

	disconnectedCallback() {
		this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.removeEventListener('scroll', this.onScrollHandler);
	}

	createObserver() {
		let observer = new IntersectionObserver((entries, observer) => {
		this.headerBounds = entries[0].intersectionRect;
		observer.disconnect();
		});

		if (this.header) {
			observer.observe(this.header);
		}
	}

	onScroll() {
		const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
		this.colorScheme = document.querySelector('main').querySelectorAll('.shopify-section')[0]?.querySelector('[data-header-transparent]')?.getAttribute('data-header-transparent-color-scheme');
		
		if (this.headerIsAlwaysSticky) {
			if (this.header.classList.contains("color-background-overlay")) {
				if (scrollTop > this.header.offsetHeight + 1) {
					this.header.classList.remove('color-background-overlay');
					/*if (this.colorScheme)
						this.header.classList.remove(this.colorScheme);*/
					this.header.classList.forEach(className => {
						if (className.startsWith('color-background-') && className != 'color-background-overlay') {
							this.header.classList.remove(className);
						}
					});
					this.header.classList.add('shopify-section-header-scroll');
					this.header.classList.add('color-background-overlay-hidden');
				};
			};

			if (this.header.classList.contains('color-background-overlay-hidden')) {
				if (scrollTop < this.header.offsetHeight) {
					this.header.classList.add('color-background-overlay');
					if (this.colorScheme)
						this.header.classList.add(this.colorScheme);	
					this.header.classList.remove('shopify-section-header-scroll');
					this.header.classList.remove('color-background-overlay-hidden');
				};
			};
		}

		if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
			if (this.preventHide) return;
			requestAnimationFrame(this.hide.bind(this));
		} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
			if (!this.preventReveal) {
				requestAnimationFrame(this.reveal.bind(this));
			} else {
				window.clearTimeout(this.isScrolling);

				this.isScrolling = setTimeout(() => {
					this.preventReveal = false;
				}, 66);

				requestAnimationFrame(this.hide.bind(this));
			}
		} else if (scrollTop <= this.headerBounds.top) {
			requestAnimationFrame(this.reset.bind(this));
		}

		this.currentScrollTop = scrollTop;
	}

	hide() {
		if (this.headerIsAlwaysSticky) {
			this.header.classList.add('shopify-section-header-scroll')
			return;
		}
		this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
		this.closeMenuDisclosure();
	}

	reveal() {
		if (this.headerIsAlwaysSticky) {
			this.header.classList.add('shopify-section-header-scroll')
			return;
		}
		this.header.classList.add('shopify-section-header-sticky', 'animate');
		this.header.classList.remove('shopify-section-header-hidden');

		if (this.header.classList.contains('color-background-overlay')) {
			this.header.classList.remove('color-background-overlay');
			/*if (this.colorScheme)
				this.header.classList.remove(this.colorScheme);*/
			this.header.classList.forEach(className => {
				if (className.startsWith('color-background-') && className != 'color-background-overlay') {
					this.header.classList.remove(className);
				}
			});
			this.header.classList.add('color-background-overlay-hidden');
		}
	}

	reset() {
		this.colorScheme = document.querySelector('main').querySelectorAll('.shopify-section')[0]?.querySelector('[data-header-transparent]')?.getAttribute('data-header-transparent-color-scheme');
		if (this.headerIsAlwaysSticky) {
			this.header.classList.remove('shopify-section-header-scroll')
			return;
		}
		this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');

		if (this.header.classList.contains('color-background-overlay-hidden')) {
			this.header.classList.add('color-background-overlay');
			if (this.colorScheme)
				this.header.classList.add(this.colorScheme);
			this.header.classList.remove('color-background-overlay-hidden');
		}
	}

	closeMenuDisclosure() {
		this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
		if (typeof DetailsDisclosure !== 'undefined') {
			this.disclosures.forEach((disclosure) => {
				disclosure.close();
			});
		}
		this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
			this.disclosureLists.forEach((disclosureList) => {
				disclosureList.setAttribute('hidden', true); 
			});
		}
	}

	customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
	class CartNote extends HTMLElement {
		constructor() {
			super();

			this.addEventListener(
				'change',
				debounce((event) => {
					const body = JSON.stringify({ note: event.target.value });
					fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
				}, 300)
			);
		}
	}

	customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
	class ProductModal extends ModalDialog {
		constructor() {
			super()
		}

		hide() {
			super.hide()
			window.pauseAllMedia()
		}

		show(opener) {
			super.show(opener)
			this.showActiveMedia()
		}

		showActiveMedia() {
			const activeMedia = this.querySelector(
				`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`
			)

			if (
				activeMedia.nodeName == 'DEFERRED-MEDIA' &&
				activeMedia
					.querySelector('template')
					?.content?.querySelector('.js-youtube')
			) {
				activeMedia.loadContent()
			}
		}
	}

	customElements.define('product-modal', ProductModal)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["z3-feature-videos"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('z3-feature-videos'))customElements.define('z3-feature-videos',class extends HTMLElement{
connectedCallback(){if(this.ready)return;this.ready=true;this.abort=new AbortController();const on=(el,type,fn)=>el.addEventListener(type,fn,{signal:this.abort.signal});this.track=this.querySelector('.z3fv__track');this.cards=[...this.querySelectorAll('[data-index]')];this.dialog=this.querySelector('dialog');this.player=this.querySelector('.z3fv__player');this.dots=[...this.querySelectorAll('[data-dot]')];this.index=0;this.current=0;this.cards.forEach((card,i)=>on(card,'click',()=>this.open(i)));this.dots.forEach((dot,i)=>on(dot,'click',()=>this.scroll(i)));on(this.querySelector('[data-prev]'),'click',()=>this.scroll(this.current-1));on(this.querySelector('[data-next]'),'click',()=>this.scroll(this.current+1));on(this.track,'scroll',()=>{cancelAnimationFrame(this.frame);this.frame=requestAnimationFrame(()=>this.progress())});on(this.querySelector('[data-close]'),'click',()=>this.dialog.close());on(this.querySelector('.z3fv__retry'),'click',()=>{const v=this.player.querySelector('video');if(v)this.start(v)});on(this.dialog,'close',()=>this.cleanup());on(this.dialog,'click',e=>{if(e.target!==this.dialog)return;const r=this.dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)this.dialog.close()});on(this.querySelector('[data-video-prev]'),'click',()=>this.open((this.index-1+this.cards.length)%this.cards.length));on(this.querySelector('[data-video-next]'),'click',()=>this.open((this.index+1)%this.cards.length));on(this.querySelector('[data-return]'),'click',()=>{this.dialog.close();const buy=[...document.querySelectorAll('form[action*="/cart/add"] button[type="submit"]')].find(el=>el.getClientRects().length&&!el.disabled);buy?.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth',block:'center'});buy?.focus({preventScroll:true})});this.progress()}
scroll(i){i=Math.max(0,Math.min(this.cards.length-1,i));const item=this.cards[i].parentElement;this.track.scrollTo({left:item.offsetLeft-this.track.firstElementChild.offsetLeft,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'})}
progress(){if(!this.cards.length)return;const left=this.track.getBoundingClientRect().left+parseFloat(getComputedStyle(this.track).paddingLeft);let best=Infinity;this.cards.forEach((c,i)=>{const distance=Math.abs(c.getBoundingClientRect().left-left);if(distance<best){best=distance;this.current=i}});this.querySelector('[data-progress]').textContent=`${this.current+1} / ${this.cards.length}`;this.dots.forEach((d,i)=>d.setAttribute('aria-current',String(i===this.current)));this.querySelector('[data-prev]').disabled=this.current===0;this.querySelector('[data-next]').disabled=this.current===this.cards.length-1}
stop(){clearTimeout(this.loadingTimer);const v=this.player.querySelector('video');if(v){v.pause();v.removeAttribute('src');v.querySelectorAll('source').forEach(s=>s.removeAttribute('src'));v.load()}this.player.replaceChildren()}
open(i){if(this.cards[i].disabled)return;this.index=i;if(!this.dialog.open){this.lastFocus=document.activeElement;this.oldOverflow=document.body.style.overflow;this.dialog.showModal();document.body.style.overflow='hidden'}this.stop();this.querySelector('[data-modal-title]').textContent=this.cards[i].querySelector('.z3fv__title').textContent;this.querySelector('[data-modal-count]').textContent=`${i+1} / ${this.cards.length}`;this.querySelector('.z3fv__error').hidden=true;this.player.append(this.cards[i].parentElement.querySelector('template').content.cloneNode(true));const v=this.player.querySelector('video');v.playsInline=true;v.preload='metadata';const source=v.querySelector('source');if(source)v.src=source.src;v.addEventListener('playing',()=>{clearTimeout(this.loadingTimer);this.querySelector('.z3fv__loading').hidden=true;this.querySelector('.z3fv__retry').hidden=true});v.addEventListener('error',()=>{clearTimeout(this.loadingTimer);this.querySelector('.z3fv__loading').hidden=true;this.querySelector('.z3fv__error').hidden=false;this.querySelector('.z3fv__retry').hidden=false});v.load();this.start(v);this.querySelector('[data-close]').focus()}
start(v){this.querySelector('.z3fv__loading').hidden=false;this.querySelector('.z3fv__retry').hidden=true;this.querySelector('.z3fv__error').hidden=true;clearTimeout(this.loadingTimer);this.loadingTimer=setTimeout(()=>{if(this.player.contains(v)&&v.readyState<3){this.querySelector('.z3fv__loading').hidden=true;this.querySelector('.z3fv__retry').hidden=false}},8000);v.play().catch(()=>{if(!this.player.contains(v))return;clearTimeout(this.loadingTimer);this.querySelector('.z3fv__loading').hidden=true;this.querySelector('.z3fv__retry').hidden=false})}
cleanup(){this.stop();document.body.style.overflow=this.oldOverflow||'';this.lastFocus?.focus({preventScroll:true})}
disconnectedCallback(){if(this.dialog?.open)this.dialog.close();this.abort?.abort();cancelAnimationFrame(this.frame);this.ready=false}
});

  } catch(e) { console.error(e); }
})();
})();
